module.exports = [{
      plugin: require('D:/ionic/Project/landing-page/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
